import LooseItemStockListTable from './looseItemStockListTable.container';

export default LooseItemStockListTable